let showData = {};
let what = 'body';
const oncls = 'interaction-active';
const interactionName = 'interaction--swap-text';
let timeout;

function init(item) {
  const triggerEvent = `${interactionName}-event`;

  if (item) {
    what = item;
  }

  showData = {
    what,
    triggerEvent,
  };

  $(what).on(`${triggerEvent}`, (e, target) => {
    e.preventDefault();
    e.stopPropagation();

    doAnimation(target);
  });
}

function doAnimation(target) {
  const button = target;

  if (
    button &&
    button.classList.contains(interactionName) &&
    !button.classList.contains(oncls)
  ) {
    button.style.minWidth = `${button.offsetWidth}px`;
    button.style.minHeight = `${button.offsetHeight}px`;
    button.classList.add(oncls);

    timeout = setTimeout(() => {
      button.classList.remove(oncls);
    }, 1250);
  }
}

function destroy() {
  $(showData.what).off(showData.triggerEvent);
  clearTimeout(timeout);
}

module.exports = {
  init,
  destroy,
};
